import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { capitalizeString } from '../../../utils/jsUtils';
import noop from '../../../utils/noop';
import { SubMenuStyles } from './SubMenu.styles';

const SubMenu = ({ onCambiar, isMapView, comunaName, view, setIsMapView, setView, regionName, shouldRender }) => {
  return (
    <>
      <div className={cx('sub-header', shouldRender.zoneMenu && 'zone-header-screen')}>
        <div className="zone-selected">
          <div
            role="button"
            id="screen3-zone-change"
            tabIndex={0}
            onKeyDown={noop}
            onClick={onCambiar}
            className={cx('zone-change', isMapView && 'map-view')}
          >
            <span>
              {capitalizeString(comunaName)}, {capitalizeString(regionName)}
            </span>
            <span className="arrow_down" />
          </div>
        </div>
        {!shouldRender.viewButtons && (
          <div className={cx('view-button')}>
            <span
              role="button"
              tabIndex={0}
              onKeyDown={noop}
              onClick={() => {
                setView('map');
                setIsMapView(true);
              }}
              className={cx('map-view-btn', view === 'map' && 'active')}
            />
            <span
              role="button"
              tabIndex={0}
              onKeyDown={noop}
              onClick={() => {
                setView('list');
                setIsMapView(false);
              }}
              className={cx('list-view-btn', view === 'list' && 'active')}
            />
          </div>
        )}
      </div>
      <style jsx>{SubMenuStyles}</style>
    </>
  );
};

SubMenu.defaultProps = {
  view: 'map',
};

SubMenu.propTypes = {
  onCambiar: PropTypes.func.isRequired,
  isMapView: PropTypes.bool.isRequired,
  comunaName: PropTypes.string.isRequired,
  view: PropTypes.string,
  setIsMapView: PropTypes.func.isRequired,
  setView: PropTypes.func.isRequired,
  regionName: PropTypes.string.isRequired,
  shouldRender: PropTypes.shape({
    zoneMenu: PropTypes.bool.isRequired,
    viewButtons: PropTypes.bool.isRequired,
  }).isRequired,
};

export default SubMenu;
